/**
 * useConsentItems
 * fetch consentItems for all children of a parent
 * update consentItems for a child
 */
import { useEffect } from 'react';
import { PARENT_ROLE, MODULES_IMAGEPREFERENCES } from 'containers/User/constants.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import { useApi2, useApi2call } from 'containers/Api2/index.js';
import useModules from 'containers/User/useModules.js';

function useConsentItems() {
  const { connections, type } = useCurrentRole();
  const api2call = useApi2call();
  const students = useApi2({ selector: 'students' });
  const modules = useModules();

  function getItems() {
    if (type === PARENT_ROLE) {
      connections.forEach((connection) => {
        api2call({ url: `students/${connection.id}/consentitems` });
      });
    }
  }

  function studentHasMissing(student) {
    if (!student || !students[student.id]?.consentitems) return false;
    const { consentitems } = students[student.id];
    return consentitems.list?.some((id) => consentitems[id].consent === null);
  }

  function setConsent(studentId, itemId, consent) {
    const url = `students/${studentId}/consentitems`;
    const options = {
      method: 'POST',
      url,
      body: {
        values: [{ id: itemId, consent }],
      },
      withPromise: true,
    };
    return api2call(options);
  }

  const loading = connections.some((connection) => students[connection.id]?.consentitems?.loading);
  const studentItems = !loading && connections.map((connection) => ({ id: connection.id, student: connection, items: students[connection.id]?.consentitems }));
  const hasMissing = !loading && connections.some(studentHasMissing);
  useEffect(getItems, [type, connections]);

  if (type !== PARENT_ROLE || !modules.includes(MODULES_IMAGEPREFERENCES)) {
    return { loading: false, hasMissing: false, studentItems: [] };
  }

  return { loading, hasMissing, studentItems, setConsent };
}

export default useConsentItems;
